import { useMemo } from 'react';
import { PortvilleBillingSettings } from '../types/portvilleBilling';
import { PortvilleRoomWithResidency } from '../types/portvilleRoom';

export interface BillingPageStatistics {
  totalRooms: number;
  completedSettings: number;
  neededSettings: number;
  completionRate: number;
}

export const useBillingStatistics = (
  allRooms: PortvilleRoomWithResidency[] | null,
  billingSettings: PortvilleBillingSettings[] | null
): BillingPageStatistics => {
  return useMemo(() => {
    const totalRooms = allRooms?.length || 0;
    const completedSettings = billingSettings?.length || 0;
    const neededSettings = Math.max(0, totalRooms - completedSettings);
    const completionRate = totalRooms > 0 ? Math.round((completedSettings / totalRooms) * 100) : 0;

    return {
      totalRooms,
      completedSettings,
      neededSettings,
      completionRate
    };
  }, [allRooms?.length, billingSettings?.length]);
};